import { AttachmentFolderPickerProperties } from '../types/AttachmentFolderPickerProperties';
import { getStore } from '../store/store';
import { initializeAttachmentFolderPicker } from '../actions/publicActions';
import { mutator } from 'satcheljs';
import { openAttachmentFolderPicker } from '../actions/internalActions';

mutator(openAttachmentFolderPicker, actionMessage => {
    initializeProviderViewState(actionMessage.properties);
});

mutator(initializeAttachmentFolderPicker, actionMessage => {
    initializeProviderViewState(actionMessage.properties);
});

function initializeProviderViewState(properties: AttachmentFolderPickerProperties) {
    const { providerInfo } = properties;
    const store = getStore();

    store.providerViewState = providerInfo;
}
